<template>
    <div>
      <div class="content-header  primary_filters bulk-assign-btn ">
        <div class="content-header content-header-left pad0">
          <div class="filters-row align-center">
            <div class="con-select" >
              <div class="selection_search casetype ml-0">
                <div class="search" >
                  <div class="vs-component vs-con-input-label vs-input is-label-placeholder vs-input-primary">
                    <div class="vs-con-input">
                      <vs-input :key="'searchtxt'" icon-pack="feather" icon="icon-search" :placeholder="'Search by Case No/Beneficiary'"
                        class="is-label-placeholder" v-model.lazy="searchtxt" @input="searchCases" />
                    </div>
                  </div>
                </div>
              </div>
            </div> 
            <div class="con-select selection_search ">
              <multiselect @input="changedPetitionVisaType()" v-model="selectedPetitionType" :options="petitionTypes" :multiple="false"
                :hideSelected="false" :close-on-select="true" :clear-on-select="false" :preserve-search="true"
                placeholder="Case Type" label="name" track-by="name" :preselect-first="false">
                <template slot="selection" slot-scope="{ values, isOpen }">
                  <span class="multiselect__selectcustom" v-if="values.length && !isOpen">{{ values.length }}
                    Case Type(s)</span>
                  <span class="multiselect__selectcustom" v-if="values.length && isOpen"></span>
                </template>  
              </multiselect>
            </div>
            <div class="con-select selection_search" v-if="selectedPetitionType">
              <multiselect @input="changedPetitionSubType()" v-model="selectedPetitionSubType" :options="petitionSubTypes" :multiple="false"
                :hideSelected="false" :close-on-select="true" :clear-on-select="false" :preserve-search="true"
                placeholder="Subtype" label="name" track-by="name" :preselect-first="false">
                <template slot="selection" slot-scope="{ values, isOpen }">
                  <span class="multiselect__selectcustom" v-if="values.length && !isOpen">{{ values.length }}
                    Case Type(s)</span>
                  <span class="multiselect__selectcustom" v-if="values.length && isOpen"></span>
                </template>  
              </multiselect>
            </div>
            <div class="con-select  selection_search" v-if="selectedPetitionType && selectedPetitionSubType">
              <multiselect @input="updateInvoices" v-model="selectedFillingFee" :options="fillingFeeList" :multiple="true"
                :hideSelected="true" :close-on-select="false" :clear-on-select="false" :preserve-search="true"
                placeholder="Select Filing Fee" label="name" track-by="name" :preselect-first="false">
                <template slot="selection" slot-scope="{ values, isOpen }">
                  <span class="multiselect__selectcustom" v-if="values.length && !isOpen">{{ values.length }}
                    Filing Fee(s)</span>
                  <span class="multiselect__selectcustom" v-if="values.length && isOpen"></span>
                </template>  
              </multiselect>
            </div>  
            
          </div>
        </div>
        <div class="content-header-right">
          <!--filter dropdown-->

        
          <vs-dropdown vs-custom-content vs-trigger-click v-if="false">
            <vs-button color="primary" class="filter-btn" type="border" icon-pack="feather" icon="icon-chevron-down"
              icon-after>
              <img src="@/assets/images/main/icon-filter.svg" /> Filters
            </vs-button>
            <vs-dropdown-menu ref="filter_menu" class="filters-content">
              <div class="filters-form-fileds">
                <div class="form-container">
                  <div class="vx-row">
                    <div class="vx-col md:w-1/3 w-full con-select filters-search">
                      <label class="typo__label">Title</label>
                      <vs-input :key="'filter_searchtxt'" icon-pack="feather" icon placeholder="Search by Case No/Beneficiary"
                        class="is-label-placeholder" v-model="filter_searchtxt" />
                    </div>
                    <div class="vx-col md:w-1/3 w-full con-select"
                      v-if="[3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13].indexOf(getUserRoleId) > -1 && getTenantTypeId != 2">
                      <label class="typo__label">Petitioner</label>
                      <multiselect @input="changedperitioners()" v-model="selected_peritioners" :options="petitionersList"
                        :multiple="true" :hideSelected="true" :close-on-select="false" :clear-on-select="false"
                        :preserve-search="true" placeholder="Select Petitioner" label="name" track-by="name"
                        :preselect-first="false" @search-change="peritioners_search_fun">
                        <template slot="selection" slot-scope="{ values, isOpen }">
                          <span class="multiselect__selectcustom" v-if="values.length && !isOpen">{{ values.length }}
                            Petitioner(s) Selected</span>
                          <span class="multiselect__selectcustom" v-if="values.length && isOpen"></span>
                        </template>
  
                      </multiselect>
  
                    </div>
                    <!-- <div class="vx-col md:w-1/3 w-full con-select filters-search">
                        <label class="typo__label">Petitioner</label>
                        <multiselect  v-model="Petitioner" :options="Petitioneroptions">
                        </multiselect> 
                      </div> -->
                    <div class="vx-col md:w-1/3 w-full con-select filters-search">
                      <label class="typo__label">Case Type</label>
                      <multiselect @input="changedperitioners()" v-model="selectedtypeNames" :options="cap" :multiple="true"
                        :hideSelected="true" :close-on-select="false" :clear-on-select="false" :preserve-search="true"
                        placeholder="Select Case Type" label="name" track-by="name" :preselect-first="false">
                        <template slot="selection" slot-scope="{ values, isOpen }">
                          <span class="multiselect__selectcustom" v-if="values.length && !isOpen">{{ values.length }}
                            Case Type(s) Selected</span>
                          <span class="multiselect__selectcustom" v-if="values.length && isOpen"></span>
                        </template>
  
                      </multiselect>
                    </div>
                    <div class="vx-col md:w-1/3  w-full con-select filters-search" v-if="false">
                      <div class=" select-large">
                        <label for="" class="typo__label">Degree Level</label>
                        <multiselect v-model="selectedEducations" :options="education_types" :multiple="true"
                          :hideSelected="true" :close-on-select="false" :clear-on-select="false" :preserve-search="true"
                          placeholder="Select Degree Level" label="name" track-by="name" :preselect-first="false">
                          <template slot="selection" slot-scope="{ values, isOpen }">
                            <span class="multiselect__selectcustom" v-if="values.length && !isOpen">{{ values.length }}
                              Degree(s) Selected</span>
                            <span class="multiselect__selectcustom" v-if="values.length && isOpen"></span>
                          </template>
  
                        </multiselect>
                      </div>
                    </div>
                    <div class="vx-col md:w-1/3 w-full con-select" v-if="false">
                      <label class="typo__label">Graduation Period</label>
                      <date-range-picker :maxDate="new Date()" :autoApply="autoApply" :ranges="false" :opens="'left'"
                        v-model="selected_createdDateRange"></date-range-picker>
                    </div>
                    <div class="vx-col md:w-1/3  w-full con-select filters-search">
                      <div class=" select-large">
                        <label for="" class="typo__label">Case Status </label>
                        <multiselect v-model="selectedStatus" :options="caseStatusList" :multiple="true"
                          :hideSelected="true" :close-on-select="false" :clear-on-select="false" :preserve-search="true"
                          placeholder="Select status" label="name" track-by="name" :preselect-first="false">
                          <template slot="selection" slot-scope="{ values, isOpen }">
                            <span class="multiselect__selectcustom" v-if="values.length && !isOpen">{{ values.length }}
                              Status(s) Selected</span>
                            <span class="multiselect__selectcustom" v-if="values.length && isOpen"></span>
                          </template>
  
                        </multiselect>
                      </div>
                    </div>
                    <div class="vx-col md:w-1/3 w-full con-select">
                      <label class="typo__label">State of the Case</label>
                      <multiselect v-model="initStatusIdsFilter" @input="changedInitStatus(initStatusIdsFilter)"
                        :options="updatedInitStatus" :multiple="false" :hideSelected="false" :close-on-select="true"
                        :clear-on-select="false" :preserve-search="true" placeholder="Select State of the case" label="name"
                        track-by="name" :preselect-first="false">
  
                        <template slot="selection" slot-scope="{ values, isOpen }">
                          <span class="multiselect__selectcustom" v-if="values.length && !isOpen">{{ values.length }}
                            Status Selected</span>
                          <span class="multiselect__selectcustom" v-if="values.length && isOpen"></span>
                        </template>
                      </multiselect>
                    </div>
                    <div class="vx-col md:w-1/3 w-full con-select client_select" v-if="false">
                      <label class="typo__label">Client Default User</label>
                      <multiselect v-model="selected_default_users" :options="defaultUserList"
                        :multiple="true" :hideSelected="true" :close-on-select="false" :clear-on-select="false"
                        :preserve-search="true" placeholder="Select Client Default User" label="name" track-by="name"
                        :preselect-first="false">
                        <template slot="selection" slot-scope="{ values, isOpen }">
                          <span class="multiselect__selectcustom" v-if="values.length && !isOpen">{{ values.length }}
                            User(s) Selected</span>
                          <span class="multiselect__selectcustom" v-if="values.length && isOpen"></span>
                        </template>
  
                      </multiselect>
  
                    </div>
                    <div class="vx-col md:w-1/3 w-full con-select" v-if="isSlg && false">
                      <label class="typo__label">Invoice Status</label>
                      <multiselect v-model="selected_billing_status" :options="billingStatusList"
                        :multiple="true" :hideSelected="true" :close-on-select="false" :clear-on-select="false"
                        :preserve-search="true" placeholder="Select Invoice Status" label="name" track-by="name"
                        :preselect-first="false">
                        <template slot="selection" slot-scope="{ values, isOpen }">
                          <span class="multiselect__selectcustom" v-if="values.length && !isOpen">{{ values.length }}
                            Statu(s) Selected</span>
                          <span class="multiselect__selectcustom" v-if="values.length && isOpen"></span>
                        </template>
  
                      </multiselect>
  
                    </div>
                    <div class="vx-col md:w-1/3 w-full con-select" v-if="false">
                      <label class="typo__label">Premium Processing</label>
                      <multiselect @input="$router.push({ query: {} })" v-model="selectedpremiumProcessing"
                        :options="premiumProcessingList" :multiple="true" :hideSelected="true" :close-on-select="false"
                        :clear-on-select="false" :preserve-search="true" placeholder="Select Premium Processing"
                        label="name" track-by="name" :preselect-first="false">
  
                        <template slot="selection" slot-scope="{ values, isOpen }">
                          <span class="multiselect__selectcustom" v-if="values.length && !isOpen">{{ values.length }}
                            Premium Processing(s) Selected</span>
                          <span class="multiselect__selectcustom" v-if="values.length && isOpen"></span>
                        </template>
                      </multiselect>
                    </div>
                  </div>
                </div>
              </div>
              <div class="filters-status">
                <div class="left-buttons"></div>
                <div class="right-buttons">
                  <vs-button color="success" class="save" type="filled" v-on:click="set_filter()">Apply</vs-button>
                  <vs-button color="dark" class="cancel" type="filled" v-on:click="clear_filter($event)">Clear</vs-button>
                </div>
              </div>
            </vs-dropdown-menu>
          </vs-dropdown>
          <vs-button color="primary" type="border" class="light-blue-btn nowrap"
            @click="resetConfiramtionPopup = true"  v-if="getselectedForInvoicesList">Reset <span>
            <img class="add-user-icon ml-2" src="@/assets/images/main/add-user.svg">
          </span></vs-button>

          <vs-button color="primary" type="border" class="light-blue-btn nowrap"
          @click="generateBulkInvoices()"
          v-if="getselectedForInvoicesList">

          Create Invoice <span>
            <img class="add-user-icon ml-2" src="@/assets/images/main/add-user.svg">
          </span></vs-button>
           
        </div>
      </div>
      <!-- noDataText resetInvoices()-->
      <NoDataFound ref="NoDataFoundRef" :loading="isListloading" v-if="pendingInvoiceList.length == 0" content=""
        :heading="callFromSearch ? 'No Results Found' : 'No Results Found'" type='petitions' />
      <div class="accordian-table custom-table custom-tableV2" v-if="pendingInvoiceList.length > 0">
        
        <div class="vs-table--content">
          <div class="vs-con-tbody">
            <table class="vs-table vs-table--tbody-table">
              <thead class="vs-table--thead">
                <tr>
                  <th>
  
                    <div class="vs-table-text d-flex align-center">
                      <vs-checkbox :disabled="!enableSelectedAll"
                      @change="selectAllforInvoices()" :name="'selecteAll'" v-model="selectAllInvoices"
                      ></vs-checkbox>
                      <a @click="sortMe('beneficiaryCustomId')"
                        v-bind:class="{ 'sort_ascending': sortKeys['beneficiaryCustomId'] == 1, 'sort_descending': sortKeys['beneficiaryCustomId'] != 1 }">Case No
                      </a>
                    </div>
                  </th>
                  <th>
                    <div class="vs-table-text">
                      <a @click="sortMe('beneficiaryName')"
                        v-bind:class="{ 'sort_ascending': sortKeys['beneficiaryName'] == 1, 'sort_descending': sortKeys['beneficiaryName'] != 1 }">Beneficiary</a>
                    </div>
                  </th>
                  <th>
                    <div class="vs-table-text">
                      <a @click="sortMe('petitionType')"
                        v-bind:class="{ 'sort_ascending': sortKeys['petitionType'] == 1, 'sort_descending': sortKeys['petitionType'] != 1 }">Case Type</a>
                    </div>
                  </th>
                  <th>
                    <div class="vs-table-text">
                      Filing Fee
                      <!-- <a @click="sortMe('createdOn')"
                        v-bind:class="{ 'sort_ascending': sortKeys['createdOn'] == 1, 'sort_descending': sortKeys['createdOn'] != 1 }"></a> -->
                    </div>
                  </th>
                  <th>
                    <div class="vs-table-text">
                      <a @click="sortMe('issuedToDetails')"
                        v-bind:class="{ 'sort_ascending': sortKeys['issuedToDetails'] == 1, 'sort_descending': sortKeys['issuedToDetails'] != 1 }">Issued To</a>
                    </div>
                  </th>
                  
                  
                  
                  <th>
                    <div class="vs-table-text">
                      <a @click="sortMe('invoiceRaiseDate')"
                        v-bind:class="{ 'sort_ascending': sortKeys['invoiceRaiseDate'] == 1, 'sort_descending': sortKeys['invoiceRaiseDate'] != 1 }">Pending Since</a>
                    </div>
                  </th>
                  
                  <!-- <th>
                    <div class="vs-table-text">
                      <a @click="sortMe('caseStatus')"
                        v-bind:class="{ 'sort_ascending': sortKeys['caseStatus'] == 1, 'sort_descending': sortKeys['caseStatus'] != 1 }">Initiated By
                      </a>
                    </div>
                  </th> -->
                  <th class="actions">Documents</th>
                  <!-- <th>
                    <div class="vs-table-text">
                      <a @click="sortMe('paymentStatus')"
                        v-bind:class="{ 'sort_ascending': sortKeys['paymentStatus'] == 1, 'sort_descending': sortKeys['paymentStatus'] != 1 }">Payment Status</a>
                    </div>
                  </th>
                  <th class="actions">Actions
                 </th> -->
                </tr>
              </thead>
              <!-- class="cursor-pointer"  @click="showDetails(petition)" -->
              <tr class="vs-table--tr" v-for="(petition, index) in pendingInvoiceList" :key="index"> 
                <td class="td vs-table--td">
                  <span>
                    <div class="d-flex align-center">
                      <vs-checkbox @change="selectForInvoice(petition)" :disabled="!getSelectedObj({'obj':petition})" :name="'selected_' +index" v-model="petition.isInvoiceSelected"></vs-checkbox>
                      
                      <div class="cursor-pointer" @click="showDetails(petition)"> {{ petition.beneficiaryCustomId }} </div>
                    </div>
                  </span>
                </td>
                  <td class="td_label">
                  <span :title="checkProperty(petition, 'beneficiaryName')" class="wrd-substr" >{{
                    checkProperty(petition, 'beneficiaryName')
                  }}</span>
                  <span >
                    <small> {{ checkProperty(petition ,'beneficiaryEmail') }} </small>
                  </span>
                </td>
                <td class="td_label" >
                  <div >
                    {{ checkProperty(petition, 'petitionType') }} <br />
                    <small> {{ checkProperty(petition, 'subTypeName') }} </small>
                  </div>
                </td>
                <td class="td vs-table--td">
                  
                    
                  <div class="slected_items">
                    <ul>
                      <template v-for="(invoice, ind) in checkProperty(petition, 'feeDetails')">
                        <template v-if="checkProperty(invoice, 'isSelected') && !checkProperty(invoice, 'isAlreadyExist') ">
                          <li>
                            <label>
                              {{checkProperty(invoice, 'name')}}
                              <strong v-if="checkProperty(invoice, 'isEdit') == false">${{checkProperty(invoice, 'amount')}}</strong>
                              <span v-if="checkProperty(invoice, 'isEdit')">
                                <input :maxLength="6"
                                oninput="this.value = this.value.replace(/[^0-9 .]/g, '').replace(/(\..*)\./g, '$1'); this.value = this.value.replace(/ /g,'');" v-model="invoice.amount" />
                              </span>
                              <!-- <input value="25" type="text" /> -->
                            </label>       
                            <div class="list-actions" @click="updateList()" > 
                              <span v-if="checkProperty(invoice, 'isEdit') == false"  @click="petition['feeDetails'][ind]['isEdit']=true;invoice['isEdit'] = true">
                                <img src="@/assets/images/icons/edit_icon.svg"  width="16" height="16"/>                                                                                     
                              </span>
                              <span v-if="checkProperty(invoice, 'isEdit') == true" @click="petition['feeDetails'][ind]['isEdit']=false;invoice['isEdit'] = false">
                                <svg  width="14" height="14" viewBox="0 0 12 12">
                                  <path id="Path_626" data-name="Path 626" d="M6,0a6,6,0,1,0,6,6A6.023,6.023,0,0,0,6,0ZM5.274,8.729,2.646,6.1l.994-.994L5.32,6.787,8.691,3.722l.946,1.04Z" fill="#97d856"/>
                                </svg>                                                          
                              </span>
                              <!-- v-if="checkProperty(invoice, 'isEdit') == true" -->
                              <em @click="petition['feeDetails'][ind]['isEdit']=false;invoice['isEdit'] = false;invoice['isSelected'] = false;checkSelectedVal(petition, index)">x
                                <!-- <img @click="petition['feeDetails'][ind]['isEdit']=false;invoice['isEdit'] = false;invoice['isSelected'] = false" src="@/assets/images/icons/delete_icon.svg"  width="16" height="16"/>                              -->
                              </em>
                            </div>              
                        </li>
                        </template>
                        
                      </template>
                      <li class="dropdown-list">
                        <vs-dropdown ref="addLabelDropdown" vs-custom-content vs-trigger-click class="cursor-pointer menu__label IB_tooltip" >  
                          <span>+</span>
                          <div class="tooltip_cnt w-auto nowrap"><p>Add Fee</p></div>
                      <vs-dropdown-menu color="#fff" class="vx-navbar-dropdown   profileDropdown add_lebel_drpdwn"  >
                        <h6 class="sub-title padtl10">Select Applicable Fees</h6>
                          <VuePerfectScrollbar
                              ref="mainSidebarPss"
                              class="scroll-area--main-sidebar"
                              :settings="settings"
                              @ps-scroll-y="scroll"
                            >
                          <ul>
                            <template v-for="(invoice, ind) in checkProperty(petition, 'feeDetails')">
                              <li v-if="!checkProperty(invoice, 'isAlreadyExist')"> 
                                <vs-checkbox @change="checkSelectedVal(petition, index)" v-model="invoice.isSelected">{{checkProperty(invoice, 'name')}}
                                  <span v-if="checkProperty(invoice, 'online')" class="online_label">Online</span>
                                </vs-checkbox>
                              </li>
                            </template>
                          
                          </ul>
                          </VuePerfectScrollbar> 
                          <div class="btn_wrap">
                              <vs-button color="success" :disabled="loadingLabel" @click="openFilingFeePopup(petition, index)" class="save" type="filled"><img src="@/assets/images/main/create_label.svg"> Create New</vs-button>
                          </div>
                      </vs-dropdown-menu>
                      </vs-dropdown>
                      </li>
                    </ul>
                  </div>
                  <div class="custom__menu">
                    <!-- <label class="menu__label">+</label> -->
                    
                    <!-- <div class="menu__list">
                      <h6>Select Applicable Fees</h6>
                      <VuePerfectScrollbar
                          ref="mainSidebarPss"
                          class="scroll-area--main-sidebar"
                          :settings="settings"
                          @ps-scroll-y="scroll"
                        >
                      <ul>
                        <template v-for="(invoice, ind) in checkProperty(petition, 'feeDetails')">
                          <li> 
                            <vs-checkbox v-model="invoice.isSelected">{{checkProperty(invoice, 'name')}}</vs-checkbox>
                          </li>
                        </template>
                       
                      </ul>
                      </VuePerfectScrollbar> 
                   </div> -->
                 </div>
                </td>
                <td class="td_label">
                  <div >
                    {{checkProperty(petition, 'issuedToDetails')}}
                 
                    </div>
                 
                </td>
                <td class="td vs-table--td"> 
                  <template v-if="checkProperty(petition, 'invoiceRaiseDate') || checkProperty(petition, 'invoiceRaiseDate') == 0">{{checkProperty(petition, 'invoiceRaiseDate')}} day(s) </template>
                  <template v-else> - </template>
                </td> 
                <!-- checkProperty(petition, 'filingFeeDocs', 'cheques') -->
                <td class="td vs-table--td">
                  <template v-if="checkProperty(petition, 'filingFeeDocs', 'cheques') && checkProperty(petition['filingFeeDocs'], 'cheques', 'length') > 0"> 
                    <ul class="documents_new_list single_doc">
                      <li class="doc_list_item"
                          v-if="checkProperty(petition, 'filingFeeDocs', 'cheques') && checkProperty(petition['filingFeeDocs'], 'cheques', 'length') > 0">
                          <documentsView @download_or_view="download_or_view" :type="'cheques'" :showTitle="false"
                              :documentsList="checkProperty(petition, 'filingFeeDocs', 'cheques')" :petitionDetails="petition" />
                              <span class="remove"><svg class="binicon" @click="petition['filingFeeDocs']['cheques'] = [];updateList()" width="12.9" height="17.688" viewBox="0 0 12.9 17.688"><defs></defs><g transform="translate(-121.874)"><path class="a" d="M176.415,245.215a.393.393,0,0,0,.393.393h9.972a.393.393,0,0,0,.393-.393V232.487H176.415v12.728ZM184,234.653h1.473v8.564H184Zm-2.946,0h1.473v8.564h-1.473Zm-2.946,0h1.473v8.564h-1.473Z" transform="translate(-53.47 -227.921)"/><path class="a" d="M131.635,1.805V.393A.393.393,0,0,0,131.242,0h-5.837a.393.393,0,0,0-.393.393V2.3h-2.746a.393.393,0,0,0-.393.393v.993a.393.393,0,0,0,.393.393h12.114a.393.393,0,0,0,.393-.393V2.689a.393.393,0,0,0-.393-.393h-2.746V1.805Zm-1.473.41h-3.676V1.473h3.676v.742Z"/></g></svg></span>
                      </li>
                      

                    </ul>
                  </template>
                  <button v-else class="IB_primary-btn sm" @click="uploadDocuments(petition, index)">Upload</button>
                  
                    
                </td> 
              </tr>
            </table>
          </div>
        </div>
        <div class="table_footer">
          <div class="vx-col  con-select pages_select" v-if="pendingInvoiceList.length > 0">
            <label class="typo__label">Per Page</label>
            <multiselect @input="changeperPage()" v-model="perpage" :options="perPeges" :multiple="false" :allow-empty="false"
              :close-on-select="true" :clear-on-select="false" :preserve-search="true" placeholder="Per Page"
              :preselect-first="true">
  
            </multiselect>
            <span class="totla_list_count" v-if="totalCount"> Total <em>{{totalCount}}</em></span>
          </div>
          <paginate v-if="pendingInvoiceList.length > 0" v-model="page" :page-count="totalpages" :page-range="3"
            :margin-pages="2" :click-handler="pageNate"
            prev-class="vs-pagination--buttons btn-prev-pagination vs-pagination--button-prev"
            next-class="vs-pagination--buttons btn-next-pagination vs-pagination--button-next" :prev-text="'<i></i>'"
            :next-text="'<i></i>'" :container-class="'pagination vs-pagination--nav'" :page-class="'page-item'">
          </paginate>
        </div>
      </div>
      <div  v-if="showDetailsPopup" class="workflow_view_wrap taskmanagement emailtemplate" :class="{ listopen: showDetailsPopup }">
          <div class="workflow_overlay"></div>
          <div class="workflow_view_cnt questionary_cnt bulkemail_details" style="width:80%">
            <div class="workflow_view_title view__title email_title-v2" :class="{ 'pr-0': type == 'showWorkflowview' }" >
              <span class="close" @click="showDetailsPopup = false;getInvoiceList()"><x-icon size="1.5x" class="custom-class"></x-icon></span>
            </div> 
              <invoiceDetail :ref="'invoiveDetailsPopup'" @reloadDetails="reloadDetails" v-if="invoiceDetails" @download_or_view="download_or_view" :invoiceData="invoiceDetails" />
            <div> 
            </div>
            
          </div>
          
      </div>
      <vs-popup
      class="document_modal document_modal-v2 "
      :class="{ 'expand': expandModal, 'custom_close_doc_modal':showCloseIcon }"
      :title="checkProperty(selectedFile, 'name')"
      :active.sync="docPrivew"
    >
    <div class="document_actions" @click="expandModal = !expandModal">
      <figure v-if="!expandModal" class="maximize-img"><img src="@/assets/images/maximize.png"  width="18" height="18"/></figure>
      <figure v-else class="minimize-img"><img src="@/assets/images/minimize.png"  width="20" height="20"/></figure>
    </div>
    <div class="custom_close" v-if="showCloseIcon">
      <figure class="close_icon" @click="showConfrmLetterPopup = true;updateletterLoading = false;errorMessage=''">
        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 20 20"><path class="a" d="M10,0A10,10,0,1,0,20,10,10,10,0,0,0,10,0Zm4.3,12.708L12.705,14.3A36.72,36.72,0,0,0,10,11.6a37.242,37.242,0,0,0-2.706,2.7L5.7,12.708A31.208,31.208,0,0,0,8.4,10,30.784,30.784,0,0,0,5.7,7.3L7.292,5.7s2.541,2.7,2.706,2.7,2.708-2.7,2.708-2.7L14.3,7.3A36.62,36.62,0,0,0,11.591,10C11.591,10.183,14.3,12.708,14.3,12.708Z"/></svg>
      </figure>
    </div>
      <h2>
        <img
          :class="{
            pdf_view_download: docType == 'pdf',
            office_view_download: docType == 'office',
            image_view_download: docType == 'image',
          }"
          class="download-button"
          @click="downloads3file(selectedFile)"
          src="@/assets/images/download.svg"
        />
      </h2>
      <div class="pdf_loader">
        <figure v-if="formSubmited && !saveEditedFile" class="loader loader2">
          <img src="@/assets/images/main/loader.gif" />
        </figure>

        <!-- <span :class="{'pdf_view_close':docType == 'pdf', 'office_view_close':docType == 'office'  , 'image_view_close 33':docType =='image'}" class="close close2" @click="docPrivew= false"></span> -->
        <template v-if="docType == 'office'">
          <div style="height: 90vh">
            <div id="placeholder" style="height: 100%"></div>
          </div>
        </template>
        <template v-else-if="docType == 'image'">
          <img :src="docValue" />
        </template>
        <template v-else-if="docType == 'pdf'">
          <div class="pdf" style="height: 90vh">
            <iframe
              v-if="docValue != ''"
              border="0"
              style="border: 0px"
              :src="docValue"
              height="100%"
              width="100%"
            >
            </iframe>
          </div>
        </template>
      </div>
    </vs-popup>
    <vs-popup class="holamundo main-popup cls-btn" title="Upload Documents" v-if="showUploadDocs" :active.sync="showUploadDocs">
            <div class="form-container"> 
              <!-- <fileUploadNote :fileNote="true" /> -->
              <div class="vx-row">
                <div class="vx-col w-full">
                  <div class="form_group mb-5">
                    <label class="form_label">Cheques</label>
                    <div class="vs-component relative mb-0">                  
                      <file-upload
                        :multiple="false"
                        :hideSelected="true"
                        v-model="documents"
                        class="file-upload-input file_upload justify-center"
                        name="documentsUpload"
                        :accept="allDocEntity"
                        :emitCategory="selectedIndex"
                        @updateData="updateData"
                      >Upload
                      </file-upload>  
                    </div>
                    <!-- v-if="checkProperty(selectedPetition, 'filingFeeDocs', 'cheques') && checkProperty(selectedPetition['filingFeeDocs'], 'cheques', 'length') > 0" -->
                    <ul class="uploaded-list note_uploads mt-2" v-if="documents && documents.length>0" >
                      <template v-for="(file, fileindex) in documents">
                        <vs-chip
                          type="button"
                          @click="removeFiles(fileindex)"
                          :key="fileindex"
                          v-if="file.status !== false"
                          closable
                          >{{ file.name }}
                        </vs-chip>
                      </template>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div class="popup-footer relative">
              <vs-button color="dark" class="cancel" type="filled" @click="hideUploadDocs(true)">Cancel</vs-button>
              <vs-button color="success" :disabled="documents.length<=0" class="save" type="filled" @click="hideUploadDocs()">Submit</vs-button>
            </div>
        </vs-popup>
        <vs-popup class="holamundo main-popup cls-btn" title="Reset Confirmation" v-if="resetConfiramtionPopup" :active.sync="resetConfiramtionPopup">
            <div class="form-container"> 
              <div class="vx-row">
                <div class="vx-col w-full">
                      <p style="line-height: 20px">
                          By performing this action unsaved changes will be reset.
                      </p>
                  </div>
              </div>
            </div>
            <div class="popup-footer relative">
              <vs-button color="dark" class="cancel" type="filled" @click="hideConfirmation(false)">Cancel</vs-button>
              <vs-button color="success"  class="save" type="filled" @click="hideConfirmation(true)">Reset</vs-button>
            </div>
        </vs-popup>
        <modal 
     
     name="createFilingFeeModal" 
     classes="v-modal-sec createFilingFeeModal"
     :min-width="200"
     :min-height="200"
     :scrollable="true"
     :reset="true"
     width="500px"
     height="auto">
   <div class="v-modal">
      
       <div class="popup-header fromDetailsPage">
         <h2 class="popup-title">Add Filing Fee</h2>
         <span @click="createFees(false);$modal.hide('createFilingFeeModal')">
           <em class="material-icons">close</em>
         </span>
       </div>
       <form @submit.prevent data-vv-scope="newLabelform" >
       <div class="form-container">
        <div class="vx-row">
           <div class="vx-col w-1/2">
             <div class="form_group">
               <label class="form_label">Fee Type<em>*</em></label>
               <vs-input :key="'name'" name="name" v-validate="'required'" class="w-full" data-vv-as="Fee Type" v-model="newFee.name" />
               <span  class="text-danger text-sm" v-show="errors.has('newLabelform.name')" >{{ errors.first("newLabelform.name") }}</span >
             </div>
           </div>
           <div class="vx-col w-1/2">
             <div class="form_group">
               <label class="form_label">Amount<em>*</em></label>
               <vs-input :maxLength="6" :key="'amount'" name="amount" oninput="this.value = this.value.replace(/[^0-9 .]/g, '').replace(/(\..*)\./g, '$1'); this.value = this.value.replace(/ /g,'');"
                 v-validate="'required'" class="w-full" data-vv-as="Amount" v-model="newFee.amount" />
               <span  class="text-danger text-sm" v-show="errors.has('newLabelform.amount')" >{{ errors.first("newLabelform.amount") }}</span >
             </div>
           </div>
        </div>



       </div>
       <div class="popup-footer relative" style="padding: 0 25px 0 !important;">
        <span class="loader" v-if="loadingLabel" ><img src="@/assets/images/main/loader.gif" /></span>
        <!-- <vs-button color="dark" @click="$modal.hide('createFilingFeeModal')" class="cancel" type="filled">Cancel
        </vs-button> -->
        <vs-button color="dark" @click="createFees(false)" class="cancel" type="filled">Cancel
        </vs-button>
        <vs-button color="success" :disabled="loadingLabel" @click="createFees(true)"  class="save m-0" type="filled">Submit</vs-button>
       </div>
     </form>
       
   
   </div>
   </modal>  
  
  
    </div>
  </template>
  <script>
  import { XIcon, MoreVerticalIcon } from 'vue-feather-icons'
  import immiPhone from "@/views/forms/fields/phonenumber.vue";
 
  const formatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2
});
  import immiInput from "@/views/forms/fields/simpleinput.vue";
  import Paginate from "vuejs-paginate";
  import moment from 'moment'
  import _ from "lodash";
  import Vue from 'vue'
  import NoDataFound from "@/views/common/noData.vue";
  import Multiselect from "vue-multiselect-inv";
  import JQuery from "jquery";
  import addBenewPet from "@/views/common/invitePet.vue"
  import addBeneficiary from "@/views/common/addBeneficiary.vue"
  //import addBeneficiary  from "@/views/common/addBeneficiary.vue" 
  //import addPetitioner  from "@/views/common/addPetitioner.vue" 
  import DateRangePicker from "vue2-daterange-picker";
  import Datepicker from "vuejs-datepicker-inv";
  import "vue2-daterange-picker/dist/vue2-daterange-picker.css";
  import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
  import FileUpload from "@/views/FileUpload.vue";
  //import JsonExcel from "vue-json-excel";
  //Vue.component("downloadExcel", JsonExcel);
  import invoiceDetail from "@/views/invoice/invoiceDetails.vue";
  import VuePerfectScrollbar from "vue-perfect-scrollbar";
  import documentsView from "@/views/common/documentsView.vue";
  export default {
    provide() {
      return {
        parentValidator: this.$validator,
      };
    },
    watch: {
      // searchtxt: function (value) {
      //   let text = value.trim();
      //   this.page = 1
      //   if (text.length > 3 || text == '') {
      //     this.getInvoiceList(true, false);
      //   }
  
      // },
    },
    data: function () {
      return {
        cancelTokenSource: null,
        newFee:{
          'invoice':false,
          'amount':null,
          'name':"",
          'type':'other',
          'id':0
        },
        selectedFileForEdit:false,
        loadingLabel:false,
        showUploadDocs:false,
        resetConfiramtionPopup:false,
        documents:[],
        selectedPetition:null,
        selectedIndex:null,
        noDataText:'Choose Case Type & Sub Type for <br/> Pending Invoices',
        petitionTypes:[],
        petitionSubTypes:[],
        selectedPetitionType:null,
        selectedPetitionSubType:null,
        selectedFillingFee:[],
        fillingFeeList:[],
        selectedInvoicesIds:[],
        selectAllInvoices:false,
        pendingInvoiceList:[],
        masterPendingInvoiceList:[],
        selectedForInvoicesList : [],
        selectedInvoiceItems:[],
        settings: { // perfectscrollbar settings
          // maxScrollbarLength: 60,
          // wheelSpeed: .60,
        },
        formSubmited: false,

        expandModal: false,
        docPrivew: false,
        showCloseIcon:false,
        showConfrmLetterPopup:false,
        docValue: "",
        docType: "",
        selectedFile: null,
        invoiceDetails:null,
        selectedFeeItem:null,
        updatedInitStatus: [
        { _id: "637f7c565648c5150123dall", id: 9, "name": "All", "sortName": "All" },
        { _id: "637f7c565648c5150123deab", id: 1, name: "Active", sortName: "active" },
        { _id: "637f7c565648c5150123dfiled", id: 10, "name": "Filed", "sortName": "Filed" },
        { _id: "637f7c565648c5150123deac", id: 2, name: "On Hold", sortName: "on hold" },
        { _id: "637f7c565648c5150123dead", id: 3, name: "Abandoned", sortName: "abandoned" },
        { _id: "637f7c565648c5150123deae", id: 4, name: "Deleted", sortName: "deleted" }
      ],
      getFiledCasesFiltered: false,
      initStatusIdsFilter:null,
        archiving: false,
        internalErrMsg: '',
        docValue:[],
        uploading: false,
        permDeleteDocs: [],
        editor: ClassicEditor,
        internalComments: '',
        internalStatusDetails: null,
        selectedAllForArchive: false,
        selectedForArchiveList : [],
        internalStatusList:[],
        checkHeaderCheckBox: { "_id": "637f076578adb65c4c208e2d", "id": 1, "name": "Active", "sortName": "active" },
        editorConfig: {
        toolbar: ['bold', 'italic', '|', 'undo', 'redo', 'NumberedList', 'BulletedList',],
      },
        showCapRegistrations:false,
        debounce:null,
        canRegCap:null,
        showCapErrorCreatioInfo:false,
        isSlg: true,
        capCreationErrors: '',
        newCapFormSubmited: false,
        withAccount: 'true',
        newBeneficiary: [
          {
            firstName: '',
            middleName: '',
            lastName: '',
            name: "",
            email: "",
            phone: "",
            phoneCountryCode: { countryCode: '', countryCallingCode: '' }
          },
        ],
        bulkBeneficiary: false,
        jsonData: [
          { "name": "SR", "email": 'ravis@innvectra.com' },
          { "name": "Ravi Kumar", "email": 'ravi@innvectra.com' }
        ],
        formerrors: {
          msg: ''
        },
        headerSelectedCaseTypes: [],
        selectedSeasons: [],
        selectedpremiumProcessing: [],
        premiumProcessingList: [{ name: 'Yes', _id: true }, { name: 'No', _id: false }],
        selectedStatus: [],
        caseStatusList: [],
        selectedEducations: [],
        education_types: [],
        selectedtypeNames: [],
        headerTypeNames: [],
        autoApply: '',
        disableOffice: false,
        branchList: [],
        selectedBranch: null,
        premiumProcessing: false,
        petitionersList: [],
        beneficiaryMasterDataList: [],
        selectedPetitioner: null,
        selectedBeneficiary: null,
        selectedUsername: null,
        selectedUser: null,
        invoiceList: [],
       
        sortKeys: {},
        sortKey: {},
        page: 1,
        perpage: 25,
        totalpages: 0,
        totalCount:0,
        perPeges: [10, 25, 50, 75, 100, 500],
        callFromSearch: false,
        isListloading: false,
        filter_searchtxt: '',
        searchtxt: '',
        header_selected_petitioners: [],
        selected_peritioners: [],
        final_selected_peritioners: [],
        encodedString: '',
        selected_createdDateRange: ["", ""],
        /////
        enableNextBtn: false,
        selectAllForArchive: false,
        selectedItem: false,
        value: null,
        values: null,
        capvalues: null,
        Petitioner: null,
  
        selected: null,
        selecte: null,
        AddBeneficiary: false,
        addPetitionerr: false,
        addcprbeneficiary: false,
        NewPetition: false,
        anonymousUser: false,
        options: ['10th / 12th Grade', 'Bachelors', 'Associate', 'Masters'],
        optionscase: ['Active', 'In active'],
        cap: [{ "name": 'Master Cap', "id": true, },
        { "name": 'Regular Cap', "id": false, }],
        Petitioneroptions: ['James', 'Michael'],
        caps: ['Master Cap', 'Regular Cap'],
        Petitioners: ['James', 'Michael'],
        season: [],
        fromUserList: ['Created', 'Sent for Petitioner Authorization', 'Petitioner Confirmation', 'Attorney Approval', 'Receipt of Payment Made', 'Submitted to USCIS', 'Selected', 'Petition Created'],
        //beneficiaryMasterDataList:['Rahul krishna' , 'Sathish'],
        PetitionerMasterDataList: ['Rahul krishna', 'Sathish'],
  
        selected_deadLineDateRange: ["", ""],
        wiseSelection: 'true',
        activeCases: true,
        getFiledCases: false,
        showDetailsPopup:false,
        selectedVisaType: null,
        visaTypes: [],
        selected_subtypes: [],
        all_subtypes: [],
        selected_statusids: [],
        case_statusids: [],
        final_selected_statusids: [],
        paymentStatus:[
    {
        "id":1,
        "name":"Created"
    },
    {
        "id":2,
        "name":"Sent"
    },
    // {
    //     "id":3,
    //     "name":"Delivery Error"
    // },
    // {
    //     "id":4,
    //     "name":"Viewed"
    // },
    {
        "id":5,
        "name":"Partially Paid"
    },
    {
        "id":6,
        "name":"Fully Paid"
    },
    // {
    //     "id":7,
    //     "name":"Deposited"
    // },
    // {
    //     "id":8,
    //     "name":"Pending"
    // }
],
        selected_paymentstatusids:[],
        final_selected_paymentstatusids:[],
        petition:null
  
      }
    },
    components: {
      documentsView,
      invoiceDetail,
      XIcon,
      MoreVerticalIcon,
      immiPhone,
      immiInput,
      //bulkBeneficiary,
      Multiselect,
      VuePerfectScrollbar,
      Paginate,
      NoDataFound,
      addBeneficiary,
      addBenewPet,
      //addBeneficiary,
      //addPetitioner,
      Datepicker,
      DateRangePicker,
      FileUpload,
  
    },
    methods: {
      hideConfirmation(action = false){
        let self = this;
        this.resetConfiramtionPopup = false;
        let list = this.pendingInvoiceList;
        let masterData = this.masterPendingInvoiceList;
        if(action){
          setTimeout(()=>{
            this.resetInvoices();
          })
          // _.forEach(list, (item,inde)=>{
          //   // console.log(inde)
          //     if(item && item['isInvoiceSelected'] && item['_id']){
          //       let findObj = _.find(masterData, {'_id':item['_id']});
          //       if(findObj){
          //         // console.log(JSON.stringify(findObj))
          //         self.selectedForInvoicesList = _.filter(self.selectedForInvoicesList, (ite) => {
          //           return ite != item['_id']
          //         })
          //         self.selectedInvoiceItems = _.filter(self.selectedInvoiceItems, (ite) => {
          //           return ite != item
          //         })
          //         // self.checkSelectedVal(item, inde)
          //         list[inde] = _.cloneDeep(findObj)
          //       }
          //     }
          //   })
          //   self.pendingInvoiceList = _.cloneDeep(list)
          
        }
        
      },
      checkSelectedVal(val, index){
        let selectedVal = val;
        let selectIndex = index;
        if(!this.getSelectedObj({'obj':selectedVal})){
          this.pendingInvoiceList[selectIndex]['isInvoiceSelected'] = false;
          this.selectedForInvoicesList = _.filter(this.selectedForInvoicesList, (item) => {
            return item != selectedVal['_id']
          })
          this.selectedInvoiceItems = _.filter(this.selectedInvoiceItems, (item) => {
            return item != selectedVal
          })
          this.updateList();
        }
      },
      createFees(action = false){
        if(action){
          this.$validator.validateAll('newLabelform').then(result => {
            if(result){
              if(this.newFee && this.checkProperty(this.newFee, 'amount')){
                this.newFee['amount'] = parseInt(this.newFee['amount'])
              }
              this.pendingInvoiceList[this.selectedIndex]['feeDetails'].push(this.newFee);
              this.newFee = {
                'invoice':false,
                'amount':null,
                'name':"",
                'type':'other',
                'id':0,
                isSelected:true
              },
              this.$modal.hide('createFilingFeeModal')
            }
          })
        }else{
          this.newFee = {
            'invoice':false,
            'amount':null,
            'name':"",
            'type':'other',
            'id':0,
            isSelected:true
          },
          this.$modal.hide('createFilingFeeModal')
        }
      },
      openFilingFeePopup(val, Index){
        this.selectedPetition=null
        this.documents = [];
        if(val){
          this.selectedPetition = val;
          this.selectedIndex = Index;
          let objIds = _.map(this.selectedPetition['feeDetails'], 'id')
          let maxId = objIds.length > 0 ? _.max(objIds) : 0;
          let time = new Date().getTime()
          this.newFee = {
            'invoice':false,
            'amount':null,
            'name':"",
            'type':'other',
            'id':time,
            isSelected:true
          },
          this.$modal.show('createFilingFeeModal')
        }
      },
      searchCases(){
      clearTimeout(this.debounce)
      this.debounce = setTimeout(() => {
        this.page=1
        this.getPendingInvoiceList();
      }, 900)
      
    },
      removeFiles(index){
        let item=this.documents[index]
      this.documents.splice(index ,1)
      this.removeFileFromS3(item)
        
        // let item = this.selectedPetition['filingFeeDocs']['cheques'][index]
        // this.selectedPetition['filingFeeDocs']['cheques'].splice(index ,1)
        // this.removeFileFromS3(item)
      },
      uploadDocuments(val, index){
        this.selectedPetition=null
        this.documents = [];
        if(val){
          this.selectedPetition = val;
          this.selectedIndex = index.toString();
          if(this.checkProperty(this.selectedPetition, 'filingFeeDocs', 'cheques')){
            this.showUploadDocs = true;
          }
        }
      },
      hideUploadDocs(action=false){
        if(action){
          this.documents = [];
          this.pendingInvoiceList[this.selectedIndex]['filingFeeDocs']['cheques'] = [];
          this.showUploadDocs = false;
        }else{
          if(this.documents && this.documents.length>0 && this.selectedIndex){
            this.pendingInvoiceList[this.selectedIndex]['filingFeeDocs']['cheques'] = this.documents;
            this.selectedPetition = null;
            this.selectedIndex = null;
            this.documents = [];
          }else{
            this.selectedPetition = null;
            this.selectedIndex = null;
            this.documents = [];
          }
          this.showUploadDocs = false;
        }
        
        
      },
      updateData(docs, category){
        this.documents = docs
        // if(category){
          
        //   this.pendingInvoiceList[category]['filingFeeDocs']['cheques'] = docs;
        // }
      },
      getVisaTypes() {
        this.page=1
        let item = {
          matcher: {
            "searchString": '',
          },
          page: this.page,
          perpage: this.perpage,
          category: "petition_types",
          "sorting": {
            "path": "name",
            "order": 1
          }
        };

        this.$store
          .dispatch("getMasterData", item)
          .then(response => {
            this.petitionTypes = [];
            this.petitionTypes = response.list;
            // if(this.petitionTypes.length>0){
            //   this.selectedPetitionType = this.petitionTypes[0];
            //   this.getPetitionSubTypes()
            // }
          });
      },
      changedPetitionVisaType(){
        this.searchtxt = '';
        this.page=1
        this.petitionSubTypes = [];
        this.selectedPetitionSubType = null;
        this.getPetitionSubTypes();
        this.getPendingInvoiceList();
      },
      getPetitionSubTypes(){
        this.searchtxt = '';
        this.page=1
        if (this.selectedPetitionType && _.has(this.selectedPetitionType, "id")) {
          let item = {
            matcher: {
              getAllSubTypes: false,
              searchString: '',
              petitionType: parseInt(this.selectedPetitionType['id']),
            },
            page: 1,
            perpage: 1000,
            category: "petition_sub_types",
            "sorting": {
              "path": "name",
              "order": 1
            }
          };
          this.$store.dispatch("getMasterData", item).then((response) => {
            this.petitionSubTypes = response.list;
          });
        }
      },
      changedPetitionSubType(){
        this.searchtxt = '';
        this.page=1
        this.getPendingInvoiceList();
        if(this.selectedPetitionSubType){
          this.getFilingFeeList();
        }else{
          this.fillingFeeList = [];
        }
        
      },
      getFilingFeeList(){
        let payLoad={
          type:this.checkProperty(this.selectedPetitionType, 'id'),
          subType:this.checkProperty(this.selectedPetitionSubType, 'id')
        }
        this.selectedFillingFee = [];
        this.fillingFeeList = [];
        let path = '/invoices/get-case-type-subType-filing-fee-categories';
        this.$store.dispatch("commonAction", { "data": payLoad, "path": path }).then((response) => {
          if(response && response['invoiceDetails'] ){
            this.fillingFeeList = response['invoiceDetails']
          }
        }).catch((err)=>{

        })
      },
      updateInvoices(val){
        if(this.checkProperty(this.selectedFillingFee, 'length')>0 && this.checkProperty(this.pendingInvoiceList, 'length')>0){
          let selectedItem = []
          _.forEach(this.selectedFillingFee, (item)=>{
            if(item['_id']){
              _.forEach(this.pendingInvoiceList, (lItem)=>{
                if(this.checkProperty(lItem, 'feeDetails', 'length')>0){
                  _.forEach(lItem['feeDetails'], (obj)=>{
                    if(item['_id'] == obj['_id']){
                      selectedItem.push(item['_id'])
                      obj['isSelected'] = true; 
                      obj['isSelectedGlobal'] = true; 
                    }
                    else{
                      if(obj['isSelectedGlobal'] && obj['isSelected'] && selectedItem.indexOf(obj['_id'])<=-1 ){
                        obj['isSelected'] = false; 
                        obj['isSelectedGlobal'] = false; 
                      }
                    }
                  })
                }
              })
            }
          })
          this.pendingInvoiceList = _.cloneDeep(this.pendingInvoiceList);
        }else if(this.checkProperty(this.pendingInvoiceList, 'length')>0 && this.checkProperty(this.selectedFillingFee, 'length')<=0){
          _.forEach(this.pendingInvoiceList, (lItem)=>{
            if(this.checkProperty(lItem, 'feeDetails', 'length')>0){
              _.forEach(lItem['feeDetails'], (obj)=>{
                if(obj['isSelectedGlobal'] && obj['isSelected'] ){
                  obj['isSelected'] = false; 
                  obj['isSelectedGlobal'] = false; 
                }
              })
            }
          })
          this.pendingInvoiceList = _.cloneDeep(this.pendingInvoiceList);
        }
      },
      resetInvoices(){
        this.getPendingInvoiceList();
        //let self = this;
        //this.pendingInvoiceList = [];
        //this.pendingInvoiceList = this.masterPendingInvoiceList
        // this.pendingInvoiceList = _.cloneDeep(this.masterPendingInvoiceList);
      },
      generateBulkInvoices(){
        let payLoad={
          items:[]
        }
        if(this.selectedInvoiceItems && this.selectedInvoiceItems.length>0){
          // let filteredArr = this.selectedInvoiceItems.map(item => ({...item,
          //   feeDetails: item.feeDetails.filter(detail => detail.isSelected)
          // }));
          // let filteredArr = this.selectedInvoiceItems.map(item => ({...item, invoices: item.feeDetails}));
          let filteredArr = [];
          let obj = {
            category:'invoices',
            invoices:[],
          }
          _.forEach(this.selectedInvoiceItems, (itm)=>{
            obj['invoices'].push(itm);
          })
          filteredArr.push(obj);
            obj = {
              category:'invoices',
              invoices:[],
            }

          payLoad['items'] = filteredArr;
        }
     
        let path = 'invoices/create-bulk-invoice-request';
        this.$store.dispatch("commonAction", { "data": payLoad, "path": path }).then((response) => {
          this.showToster({ message: response.message, isError: false });
          this.getPendingInvoiceList();
        }).catch((err)=>{
          this.showToster({ message: err, isError: true });
          this.getPendingInvoiceList();
        })
      },
      selectAllforInvoices(){
        this.selectedForInvoicesList = [];
        this.selectedInvoicesIds = [];
        this.selectedInvoiceItems = [];
        _.forEach(this.pendingInvoiceList, (item) => {
          item.isInvoiceSelected = false;
          if (this.selectAllInvoices ) {
            if(this.getSelectedObj({'obj':item})){
              item.isInvoiceSelected = true;
              this.selectedForInvoicesList.push(item._id)
              this.selectedInvoiceItems.push(item);
              if (!this.selectedInvoicesIds.includes(item['statusId'])) {
                this.selectedInvoicesIds.push(item['statusId']);
                
              }
            }
          }
        })
        // if (this.pendingInvoiceList.length > 0 && this.pendingInvoiceList.length != this.selectedForInvoicesList.length) {
        //   this.selectAllInvoices = false;
        //   this.selectedInvoicesIds=[]
        // }
      },
      selectForInvoice(caseItem) {
        this.formerrors.msg = '';
        if (this.checkProperty(caseItem, 'isInvoiceSelected') ) {
            if (this.selectedForInvoicesList.indexOf(caseItem['_id']) <= -1) {
              this.selectedForInvoicesList.push(caseItem['_id'])
              if (!this.selectedInvoiceItems.includes(caseItem)) {
                this.selectedInvoiceItems.push(caseItem);
              }
            }

        } else {
          this.selectedForInvoicesList = _.filter(this.selectedForInvoicesList, (item) => {
            return item != caseItem['_id']
          })
          this.selectedInvoiceItems = _.filter(this.selectedInvoiceItems, (item) => {
            return item != caseItem
          })
        }
        this.selectAllInvoices = false;
        if (this.selectedForInvoicesList.length > 0 && (this.pendingInvoiceList.length == this.selectedForInvoicesList.length)) {
          this.selectAllInvoices = true;
        }
      },
      scroll(){},
      updateList(){
        this.pendingInvoiceList = _.cloneDeep(this.pendingInvoiceList)
      },

      download_or_view(docItem) {
      let value = _.cloneDeep(docItem);
      this.showCloseIcon = false;
      this.expandModal= false;



      var _self = this;
      this.formSubmited = false;
      if (_.has(value, "path")) {
        value["url"] = value["path"];
        value["document"] = value["path"];
      }

      if (_.has(value, "url")) {
        value["path"] = value["url"];
        value["document"] = value["url"];
      }

      if (_.has(value, "document")) {
        value["path"] = value["document"];
        value["url"] = value["document"];
      }

      this.selectedFile = value;
      this.docValue = "";
      this.docPrivew = false;
      this.docType = false;
      this.docType = this.findmsDoctype(value);
      this.showCloseIcon = false;

      //if ( (this.docType == "office" || this.docType == "image" || this.docType == "pdf") && value.download == false ) {
      if (this.docType == "office" || this.docType == "image" || this.docType == "pdf") {
        value.url = value.url.replace(this.$globalgonfig._S3URL, "");
        value.url = value.url.replace(this.$globalgonfig._S3URLAWS, "");
        let postdata = {
          keyName: value.url,
          petitionId: value["petitionId"],
        };
        this.$store.dispatch("getSignedUrl", postdata).then((response) => {
          this.docValue = response.data.result.data;

          if (this.docType == "office") {
            document.getElementById("placeholder").innerHTML =
              "  <div  id='placeholder2' style='height:100%'></div>";
            let _editing = false;

            if ([50, 51].indexOf(this.getUserRoleId) > -1) {
              _editing = false;
            }
           
            let docViewUrl ='https://immibox.com/api/petition/post-edited-document';
            if(_.has(this.$globalgonfig, 'DOC_VIEW_URL')){
              docViewUrl = this.$globalgonfig['DOC_VIEW_URL'];
            }

            let entityId = 'cover_letter';
            if(this.checkProperty(value,'entityId')){
              entityId = value['entityId'];
            }
               
            if ( _.has(value ,'viewmode') && value.viewmode==false ) {
              _editing = true;
              if(_.has(value,'type') && _self.checkProperty(value, 'type') == 'Letter' && _.has(value,'generated') &&
              (_self.checkProperty(value, 'generated') == true || _self.checkProperty(value, 'generated') == 'true') && !value['parentId'] 
               ){
                //&& !value['parentId'] removed parentId in above condition as per requirement
                this.showCloseIcon = true; 
                // && this.checkProperty( this.$store.state ,'selectedForEditDocument') && this.checkProperty( this.$store.state ,'selectedForEditDocument', 'savedDocumentId')
              } 
            }
            var _ob = {};
            if (value.editedDocument) {
              _ob = {
               // entityId:entityId,
                petitionId: this.petition._id,
                name: value.name,
                _id: value._id,
                extn: "docx",
                formLetterType: "Letter",
                parentId: value.parentId,
              };
            } else {
              _ob = {
               // entityId:entityId,
                name: value.name,
                petitionId: this.petition._id,
                _id: value._id,
                extn: "docx",
                formLetterType: "Letter",
                parentId: value._id,
              };
            }
            var nid = value._id +  Math.round(+new Date()/1000)
            window.docEditor = new DocsAPI.DocEditor("placeholder2", {
              document: {
                c: "forcesave",
                fileType: "docx",
                key: nid,
                userdata: JSON.stringify(_ob),
                title: value.name,
                url: response.data.result.data,
                permissions: {
                  edit: _editing,
                  download: true,
                  reader: false,
                  review: false,
                  comment: false,
                },
              },

              documentType: "word",
              height: "100%",
              width: "100%",

              editorConfig: {
                userdata: JSON.stringify(_ob),
                callbackUrl:
                docViewUrl+"?entityId="+entityId+"&payload=" +
                  JSON.stringify(_ob) +
                  "&token=" +
                  _self.$store.state.token +
                  "&name=" +
                  value.name.replace(".docx", ""),
                customization: {
                  logo: {
                    image: "https://immibox.com/app/favicon.png",
                    imageDark: "https://immibox.com/app/favicon.png",
                    url: "https://immibox.com",
                  },
                  anonymous: {
                    request: false,
                    label: "Guest",
                  },
                  chat: false,
                  comments: false,
                  compactHeader: false,
                  compactToolbar: true,
                  compatibleFeatures: false,
                  feedback: {
                    visible: false,
                  },
                  forcesave: true,
                  help: false,
                  hideNotes: true,
                  hideRightMenu: true,
                  hideRulers: true,
                  layout: {
                    toolbar: {
                      collaboration: false,
                    },
                  },
                  macros: false,
                  macrosMode: "warn",
                  mentionShare: false,
                  plugins: false,
                  spellcheck: false,
                  toolbarHideFileName: true,
                  toolbarNoTabs: true,
                  uiTheme: "theme-light",
                  unit: "cm",
                  zoom: 100,
                },
              },
              events: {
                onReady: function () {},
                onDocumentStateChange: function (event) {
                  var url = event.data;
                  if (!event.data) {
                    if (value.editedDocument) {
                    }
                  }
                },
              },
            });
            //this.docValue = encodeURIComponent(response.data.result.data);
          }

          if (this.docType == "pdf") {
            var formAndLetterId = value._id;
            let parentId = '';
            // if (this.checkProperty(value,'parentId')) {
            //   parentId = value.parentId;
            // }
            //else{
            //   if (this.checkProperty(value,'generated')) {
            //     parentId = value._id;
            //   }
             
            // }
            //alert(parentId)
            var  viewmode = 0; //viewmode= 1 Enable edit AND viewmode= 0; //Disabled Edit
            let pdfViewUrl ='https://immibox.com/viewer/pdfjs-dist/web/viewerv2.html';
            
            if(_.has(this.$globalgonfig, 'PDF_VIEW_URL')){
              pdfViewUrl = this.$globalgonfig['PDF_VIEW_URL'];
            }
             

            if(_.has(value ,'viewmode')){
              if (value.viewmode) {
                viewmode = 0;
              }else{
                viewmode = 1;
                viewmode=viewmode+"&depLabel="+value.depLabel+"&depType="+value.depType+"&docUserType="+value.docUserType+"&generated="+value.generated+"&parentId="+parentId+"&formAndLetterId="+formAndLetterId+"&save=v2&docname="+value.name+"&posturl="+this.$globalgonfig._APIURL+"/&petitionId="+this.$route.params.itemId+"&entityId="+value.entityId+"&token="+this.$store.state.token
                if(_.has(this.$globalgonfig, 'PDF_EDIT_URL')){
                  pdfViewUrl = this.$globalgonfig['PDF_EDIT_URL'];
                  
                 }
              }

            }

           
            
           
            if(this.getPetitionTab != 'Forms and Letters'){
              viewmode= 0; //Disabled Edit
              if(_.has(this.$globalgonfig, 'PDF_VIEW_URL')){
                pdfViewUrl = this.$globalgonfig['PDF_VIEW_URL'];
              }
              
            }
           
            this.docValue =
            pdfViewUrl+"?view=" +
              viewmode +
              "+&file=" +
              encodeURIComponent(response.data.result.data);
          }
          this.docPrivew = true;
        });
      } else {
        this.downloads3file(value);
      }
    },
    reloadDetails(){
      if(this.checkProperty(this.selectedFeeItem, '_id')){
        this.getDetails(this.checkProperty(this.selectedFeeItem, '_id'), true)
      }
    },
        getDetails(invoiceId, callFromReload=false){

      let query ={  
        "invoiceId": invoiceId?invoiceId:''
         };    
         this.$store
          .dispatch("getList",{data:query ,path:'/invoices/details'} )
          .then(response => {
             this.invoiceDetails = response;
             if(callFromReload){
              this.$refs['invoiveDetailsPopup'].checkPaidAmount()
             }
             //console.log(JSON.stringify(response))
             this.showDetailsPopup =true;
            }).catch(error => {
             
            })
        },
        formatprice(amount) {
      return formatter.format(amount);
    },




        showDetails(item){
          let routedId = this.checkProperty(item, 'petitionId');
          if(this.checkProperty(item, 'subType') == 15){
            this.$router.push({ path: `/gc-employment-details/${routedId}`})
          }else{
            this.$router.push({ path: `/petition-details/${routedId}`})
          }
          // this.selectedFeeItem = null;
          // if(item){
          //   this.selectedFeeItem = item;
          //   this.getDetails(this.checkProperty(item, "_id"))
          // }
          
        },
      changedInitStatus(obj) {
        if (obj && obj.id == 1 || obj.id == 10 || obj.id == 9) {
          this.selected_statusids = [];
        }
        if(obj.id==10){
          this.getFiledCasesFiltered = true
        }else{
          this.getFiledCasesFiltered = false
        }
        //  _.filter(obj, (item) => {
        //  if(this.checkProperty(obj, 'id') != this.checkProperty(item, 'id')){
        //   this.activeCases =false;
        //  }
        // })
        // if(this.checkProperty(obj, 'id')==1){
        //   this.activeCases = true;
        // }
      },
      checkDeletedDocs(val) {
        this.internalErrMsg = ''
        if (this.checkProperty(val, 'id') == 1 || this.checkProperty(val, 'id') == 4) {
          this.permDeleteDocs = []
        }
      },
      
      filterInternalStatus() {
        this.internalStatusList = _.cloneDeep(this.masterDataList)
        if ([50].indexOf(this.getUserRoleId) > -1) {
          this.internalStatusList = _.filter(this.internalStatusList, (item) => {
            return [1, 4].indexOf(item.id) <= -1
          })
        }
        if (this.initStatusIdsFilter) {
          let filterStatusId = parseInt(this.checkProperty(this.initStatusIdsFilter, 'id'))
          if (filterStatusId == 3) {
            this.internalStatusList = _.filter(this.internalStatusList, (item) => {
              return [filterStatusId, 1].indexOf(item.id) <= -1
            })
          }
          else {
            this.internalStatusList = _.filter(this.internalStatusList, (item) => {
              return [filterStatusId].indexOf(item.id) <= -1
            })
          }
        }
      },
      getInternalStatusList() {
        let postData = {
          page: 1,
          perpage: 1000,
          category: "case_internal_status",
        }
        this.$store.dispatch("getMasterData", postData).then(response => {
          this.masterDataList = response.list;
  
          if ([50].indexOf(this.getUserRoleId) > -1) {
            this.internalStatusList = _.filter(response.list, (item) => {
              return [1, 4].indexOf(item.id) <= -1
            })
          }
          else {
            this.internalStatusList = this.masterDataList
          }
          if (this.checkProperty(this.$route, 'query', 'filter')) {
            try {
              let filter = this.$route['query']['filter']; this.checkProperty(this.$route, 'query', 'filter')
              var actual = JSON.parse(atob(filter));
              let keys = Object.keys(actual);
              if (this.checkProperty(keys, 'length') > 0) {
                //initStatusIdsFilter
  
                if (_.has(actual, 'matcher')) {
                  if (_.has(actual['matcher'], 'intStatusIds') && this.checkProperty(actual['matcher'], 'intStatusIds', 'length') > 0) {
                    let selectedIntStsid = actual['matcher']['intStatusIds'][0];
                    this.initStatusIdsFilter = _.find(this.internalStatusList, { 'id': selectedIntStsid });
                  }
                }
  
              }
  
            } catch (e) {
            }
          }
        });
      },
      
     
      openCreateCasePopup(action) {
        this.capCreationErrors = '';
        this.newCapFormSubmited = false;
        this.bulkBeneficiary = false;
        this.disableOffice = false;
        this.NewPetition = action;
        this.selectedPetitioner = null;
        this.selectedBeneficiary = null;
        this.selectedUsername = null;
        this.selectedUser = null;
        this.premiumProcessing = false;
        this.newBeneficiary = [
          {
            firstName: '',
            middleName: '',
            lastName: '',
            name: "",
            email: "",
            phone: "",
            phoneCountryCode: { countryCode: '', countryCallingCode: '' }
          },
        ];
        this.selectedBranch = null;
        if ([3, 4, 50].indexOf(this.getUserRoleId) <= -1) {
          if (this.checkProperty(this.getUserData, 'branchDetails')) {
            let branchDetails = this.checkProperty(this.getUserData, 'branchDetails')
            this.selectedBranch = { "name": '', '_id': '' };
            this.selectedBranch['name'] = branchDetails['name'];
            this.selectedBranch['_id'] = branchDetails['_id'];
            this.disableOffice = true;
          } else if (this.branchList && this.branchList.length == 1) {
            this.selectedBranch = this.branchList[0]
          }
        } else if (this.branchList && this.branchList.length == 1) {
          this.selectedBranch = this.branchList[0]
        }
        this.showCapErrorCreatioInfo = false;
        if(this.canRegCap ==false){
          this.showCapErrorCreatioInfo = true;
        }else{
          
        
        this.$modal.show('newCapCreationModal');
        this.$validator.reset();
       }
      },
      checkCapRegcase(callFrommounted=false){
        this.showCapErrorCreatioInfo =false;
        this.canRegCap = false;
        this.$store.dispatch("commonAction", { "data": {}, "path": "/cap-registrations/can-create-case" }).then((response) => {
          this.canRegCap = response;
          
            if (callFrommounted && this.$route.params && this.$route.params.openCreatePopup) {
            var _s = this;
            setTimeout(() => {
            _s.openCreateCasePopup(false);
            
            }, 600)
            }
          
          
          })
      },
      updateAccount() {
        let tempList = [];
        _.forEach(this.newBeneficiary, (item) => {
          item['email'] = ''
          item['phone'] = ''
          item['phoneCountryCode'] = {
            countryCode: '',
            countryCallingCode: ''
          }
          tempList.push(item)
        })
        if (tempList && this.checkProperty(tempList, 'length') > 0) {
          this.newBeneficiary = tempList
        }
      },
      getPendingInvoiceList(callFromSearch = false, callFromFilter = false) {
        if (this.cancelTokenSource) {
          this.cancelTokenSource.abort()
        }
      this.selectAllInvoices = false;
      this.callFromSearch = true;
      if (this.callFromSearch) {
        this.invoiceList = []
      }
      let tempObj={
        page: this.page,
        perpage: this.perpage,
        sortKey: this.sortKey,
      };

      let Payload={
        "matcher": {
            "rfeCases": true,
            "searchString": this.searchtxt,
            "petitionerIds": [],
            "beneficiaryIds": [],
            "branchIds": [],
            "assignedUserIds": [],
            "statusIds": [],
            "intStatusIds": [],
            "typeIds": [],
            "subTypeIds": []
        },
        "page": this.page,
        "perpage": this.perpage,
        "sorting": this.sortKey,
      };
      if(this.checkProperty(this.selectedPetitionType, 'id')){
        Payload['matcher']['typeIds'].push(this.checkProperty(this.selectedPetitionType, 'id'))
      } 
      if(this.checkProperty(this.selectedPetitionSubType, 'id')){
        Payload['matcher']['subTypeIds'].push(this.checkProperty(this.selectedPetitionSubType, 'id'))
      } 
      this.selectedForInvoicesList = [];
      this.selectedInvoicesIds = [];
      this.selectedInvoiceItems = [];
      this.pendingInvoiceList = []
      this.masterPendingInvoiceList = [];
      this.setQueryString(tempObj);
      this.isListloading = true;
      this.updateLoading(true);
      this.cancelTokenSource = new AbortController();  //commonAction
      const signal = this.cancelTokenSource.signal;
      this.$store.dispatch("commonActionWithAbort", { "data": Payload, "path": "/invoices/pending-invoice-list", cancelTokenSource: signal }).then((response) => {
        let list = response.list
        if(this.checkProperty(list, 'length')>0){
          _.forEach(list, (lItem)=>{
            lItem['isInvoiceSelected'] = false;
            if(this.checkProperty(lItem, 'feeDetails', 'length')>0){
              _.forEach(lItem['feeDetails'], (obj)=>{
                if(!_.has(obj, 'isSelected') || !obj['isSelected'] ){
                  obj['isSelected'] = false; 
                  obj['isSelectedGlobal'] = false; 
                  obj['isAlreadyExist'] = false;
                  obj['isOffline'] = true; 
                }else{
                  obj['isAlreadyExist'] = true;
                  obj['isOffline'] = true;  
                }
              })
            }
          })
          this.pendingInvoiceList = _.cloneDeep(list);
          this.masterPendingInvoiceList = _.cloneDeep(list);
        }
        this.isListloading = false;
        this.updateLoading(false);
        // this.getActiveCases = false;
        // this.invoiceList = response.list
        this.totalCount = this.checkProperty(response, 'totalCount')
        this.totalpages = Math.ceil(response.totalCount / this.perpage)
        setTimeout(() => {
          this.updateLoading(false);
        }, 10);
      })
        .catch((err) => {
          this.isListloading = false;
          this.updateLoading(false);
        })
    },
      getInvoiceList(callFromSearch = false, callFromFilter = false) {
  
        this.callFromSearch = callFromSearch
        if (this.callFromSearch) {
          this.invoiceList = []
        }
        let Payload = {
          matcher: {
            title: this.searchtxt,
            petitionerIds: this.final_selected_peritioners,
            caseType: [],
            subType: [],
            caseStatus: this.final_selected_statusids,
            paymentStatus: this.final_selected_paymentstatusids,
            createdDateRange: [],
            dueDateRange: [],
          },
          page: this.page,
          perpage: this.perpage,
          sorting: this.sortKey,
          today: moment().format('YYYY-MM-DD'),
        }
        if (this.selectedVisaType && _.has(this.selectedVisaType, 'id')) {
        if (this.checkProperty(this.selectedVisaType, 'id') != 'ALL') {
            Payload["matcher"]["caseType"] = [this.selectedVisaType['id']];
            Payload["matcher"]["subType"] = this.final_selected_subtypes;
        }

      }
      if (
        this.selected_createdDateRange["startDate"] &&
        this.selected_createdDateRange["startDate"] != "" &&
        this.selected_createdDateRange["endDate"] != "" &&
        this.selected_createdDateRange["endDate"]
      ) {
        Payload["matcher"]["createdDateRange"] = [
          this.selected_createdDateRange["startDate"],
          this.selected_createdDateRange["endDate"]
        ];
      }
      if (
        this.selected_deadLineDateRange["startDate"] &&
        this.selected_deadLineDateRange["startDate"] != "" &&
        this.selected_deadLineDateRange["endDate"] != "" &&
        this.selected_deadLineDateRange["endDate"]
      ) {
       
        Payload["matcher"]["dueDateRange"] = [
          this.selected_deadLineDateRange["startDate"],
          this.selected_deadLineDateRange["endDate"]
        ];
      }
        let tempObj={
          page: this.page,
          perpage: this.perpage,
          sortKey: this.sortKey,
        };
        this.setQueryString(tempObj);
        this.isListloading = true;
        this.updateLoading(true);
        this.$store.dispatch("commonAction", { "data": Payload, "path": "/invoices/list" }).then((response) => {
          this.isListloading = false;
          this.updateLoading(false);
          this.getActiveCases = false;
          this.invoiceList = response.list
          this.totalCount = this.checkProperty(response, 'totalCount')
          this.totalpages = Math.ceil(response.totalCount / this.perpage)
          setTimeout(() => {
            this.updateLoading(false);
          }, 10);
        })
          .catch((err) => {
            this.isListloading = false;
            this.updateLoading(false);
          })
      },
      setQueryString(obj){
        const string = JSON.stringify(obj) // convert Object to a String
        this.encodedString = btoa(string) // Base64 encode the String
        this.$route['query']['filter'] = this.encodedString;  
      },
      filterQueryPreSelect(callFromMounted=false){
        if(this.checkProperty(this.$route ,'query' ,'filter')){
          try{
            let filter =this.$route['query']['filter']; this.checkProperty(this.$route ,'query' ,'filter')
            var actual = JSON.parse(atob(filter));
            let keys = Object.keys(actual);
            if(this.checkProperty(keys ,'length') >0 ){
              if(_.has(actual ,'page') && this.checkProperty(actual ,'page')){                                     
                this.page = this.checkProperty(actual ,'page');
              }
              if(_.has(actual ,'perpage') && this.checkProperty(actual ,'perpage')){                                     
                this.perpage = this.checkProperty(actual ,'perpage');
              }
              if(_.has(actual ,'sortKey') && this.checkProperty(actual ,'sortKey')){   
                if(this.sortKeys){
                  this.sortKeys[actual['sortKey']['path']] = actual['sortKey']['order']
                }                                  
                this.sortKey = this.checkProperty(actual ,'sortKey');
              }
              if(_.has(actual ,'selectedStatus') && this.checkProperty(actual ,'selectedStatus') && this.checkProperty(actual ,'selectedStatus', 'length')>0){                                     
                this.selectedStatus = this.checkProperty(actual ,'selectedStatus');
              } 
              if(_.has(actual ,'selectedSeasons') && this.checkProperty(actual ,'selectedSeasons') && this.checkProperty(actual ,'selectedSeasons', 'length')>0){                                     
                this.selectedSeasons = this.checkProperty(actual ,'selectedSeasons');
              }
              if(_.has(actual ,'selected_peritioners') && this.checkProperty(actual ,'selected_peritioners') && this.checkProperty(actual ,'selected_peritioners', 'length')>0){                                     
                this.selected_peritioners = this.checkProperty(actual ,'selected_peritioners');
                this.changedperitioners();
              }
              if(_.has(actual ,'header_selected_petitioners') && this.checkProperty(actual ,'header_selected_petitioners') && this.checkProperty(actual ,'header_selected_petitioners', 'length')>0){                                     
                this.header_selected_petitioners = this.checkProperty(actual ,'header_selected_petitioners');
              }
              if(_.has(actual ,'selectedpremiumProcessing') && this.checkProperty(actual ,'selectedpremiumProcessing') && this.checkProperty(actual ,'selectedpremiumProcessing', 'length')>0){                                     
                this.selectedpremiumProcessing = this.checkProperty(actual ,'selectedpremiumProcessing');
              }
              if(_.has(actual ,'selectedtypeNames') && this.checkProperty(actual ,'selectedtypeNames') ){                                     
                this.selectedtypeNames = this.checkProperty(actual ,'selectedtypeNames');
              }
              if(_.has(actual ,'searchtxt') && this.checkProperty(actual ,'searchtxt') ){                                     
                this.searchtxt = this.checkProperty(actual ,'searchtxt');
              }
              if(_.has(actual ,'filter_searchtxt') && this.checkProperty(actual ,'filter_searchtxt') ){                                     
                this.filter_searchtxt = this.checkProperty(actual ,'filter_searchtxt');
              }
             // console.log("matchessss",actual)
              if(_.has(actual ,'initStatusIdsFilter') && this.checkProperty(actual ,'initStatusIdsFilter')){                                     
                this.initStatusIdsFilter = this.checkProperty(actual ,'initStatusIdsFilter');
                //console.log("this.initStatusIdsFilter",this.initStatusIdsFilter)
              } //selectedStatus
              if (_.has(actual, 'selectedStatus') && this.checkProperty(item, 'selectedStatus', 'length') > 0) {
                      let statusIds = _.map(item['selectedStatus'], (sid) => parseInt(sid))
                      //let selectedStatus = _.find(this.case_statusids ,{"id":parseInt(statusIds[0])}); 
                      this.selectedStatus = statusIds;
                      _.forEach(this.selectedStatus, (ite) => {
                        if ([12, 13, 22, 23, 24, 31].indexOf(ite) > -1) {
                          this.getActiveCases = false;
                          this.activeCases = false;
                          return false
                        }
                      })
                    }
              if(callFromMounted){
                if(this.checkProperty(this.season,'length') >0 && this.checkProperty(this.selectedSeasons,'length') <=0){                                     
                  this.selectedSeasons.push(this.season[0]);
                }
              }
              this.set_filter();
            }else{
              if(callFromMounted){
                if(this.checkProperty(this.season,'length') >0 && this.checkProperty(this.selectedSeasons,'length') <=0){                                     
                  this.selectedSeasons.push(this.season[0]);
                }
                this.set_filter();
              }else{
                this.set_filter();
              }
            }
          }catch(e){
            if(callFromMounted){
              this.set_filter(callFromMounted);
            }
          }   
        }
        else{
          if(callFromMounted){
            if(this.checkProperty(this.season,'length') >0 && this.checkProperty(this.selectedSeasons,'length') <=0){                                     
              this.selectedSeasons.push(this.season[0]);
            }
              this.set_filter(callFromMounted);
          }
        } 
      },


      remove(item, data, filindex) {
        data.splice(filindex, 1);
        //this.disablePWDstatus = false;
        this.removeFileFromS3(item)
      },
      updatecellPhoneCountryCodee(data = '', index = '') {
        this.newBeneficiary[index]['phoneCountryCode'] = data
      },
     

      clearMoreBen() {
        this.bulkBeneficiary = false;
        this.newBeneficiary = [
          {
            firstName: '',
            lastName: '',
            name: "",
            email: "",
            phone: "",
            phoneCountryCode: { countryCode: '', countryCallingCode: '' }
          },
        ];
  
      },

      pageNate(pageNum) {
  
        this.page = pageNum;
        this.getPendingInvoiceList();
      },
      changedperitioners() {
        this.$router.push({ query: {} })
        this.final_selected_peritioners = [];
        if (this.selected_peritioners.length > 0) {
          for (let i = 0; i < this.selected_peritioners.length; i++) {
            this.final_selected_peritioners.push(
              this.selected_peritioners[i]["userId"]
            );
          }
        }
        //this.get_peritioners_beneficiaries();
      },

      peritioners_search_fun(searchText) {
        clearTimeout(this.debounce)
          this.debounce = setTimeout(() => {
            this.getPetitioners(true, searchText);
          }, 900)
        
        //this.peritioners_search_value = searchValue;
        //this.get_peritioners();
      },
      changeperPage() {
        this.page = 1;
        localStorage.setItem('petitions_perpage', this.perpage);
        this.getPendingInvoiceList(true);
      },
      sortMe(sort_key = '') {
        if (sort_key != '') {
          this.sortKeys[sort_key] = this.sortKeys[sort_key] == 1 ? -1 : 1
          this.sortKey = {};
          this.sortKey = { "path": sort_key, "order": this.sortKeys[sort_key] }
          localStorage.setItem('petitions_sort_key', sort_key);
          localStorage.setItem('petitions_sort_value', this.sortKey[sort_key]);
          this.getPendingInvoiceList();
        }
      },
      getBranchList() {
  
        this.branchList = [];
        let item = {
          filters: {
            "title": '',
            "createdDateRange": [],
            "statusList": [],
            "activeList": [],
            "countryIds": [],
            "stateIds": [],
            "locationIds": []
          },
          getMasterData: true,
          page: 1,
          perpage: 1000,
          sorting: { "path": "createdOn", "order": -1 },
  
        };
        this.$store
          .dispatch("getList", { "data": item, "path": "/branch/list" })
          .then(response => {
  
            this.branchList = response.list;
            if (this.branchList.length == 1) {
              this.selectedBranch = this.branchList[0];
            }
          }).catch((error) => {
            this.branchList = [];
          })
      },

      set_filter: function (callFromMounted = false, clearSubType = false) {
        this.searchtxt = this.filter_searchtxt;
        if (clearSubType) {
        this.final_selected_subtypes = [];
        this.selected_subtypes = [];
        this.selected_statusids = [];
      }
        if (this.initStatusIdsFilter) {
          this.checkHeaderCheckBox = this.initStatusIdsFilter
          if (this.initStatusIdsFilter && this.initStatusIdsFilter.id == 1) {
            this.activeCases = true;
            this.getFiledCases = false;
          }
          else {
            this.activeCases = false;
  
          }
          if (this.initStatusIdsFilter && this.initStatusIdsFilter.id == 10) {
            this.activeCases = false;
            this.getFiledCases = true;
            
          }
          if (this.initStatusIdsFilter && [2, 3, 4, 9].indexOf(this.initStatusIdsFilter) > -1) {
            this.activeCases = false;
            this.getFiledCases = false;
           
          }
          
        
         // this.checkInternalStatusTitle()
        }
        if (this.initStatusIdsFilter == null) {
          this.activeCases = false;
          //console.log("this.initStatusIdsFilter == null")
        }
        if (this.selected_statusids) {
        if (!callFromMounted) {
          this.final_selected_statusids = [];
        }
        for (let ind = 0; ind < this.selected_statusids.length; ind++) {
          let current_index = this.selected_statusids[ind];
          this.final_selected_statusids.push(current_index["id"]);
        }
      }
      if (this.selected_paymentstatusids) {
        if (!callFromMounted) {
          this.final_selected_paymentstatusids = [];
        }
        for (let ind = 0; ind < this.selected_paymentstatusids.length; ind++) {
          let current_index = this.selected_paymentstatusids[ind];
          this.final_selected_paymentstatusids.push(current_index["id"]);
        }
      }
        if (this.selectedStatus && this.checkProperty(this.selectedStatus, 'length') > 0) {
          _.forEach(this.selectedStatus, (it) => {
            if ([7,6,8,11,9,10,91].indexOf(it['id']) > -1) {
              this.activeCases = false;
              this.initStatusIdsFilter=null
              return false
            }
          })
        }
        this.getInvoiceList();
        this.headerTypeNames = this.selectedtypeNames;
        this.header_selected_petitioners = this.selected_peritioners
        // this.$refs["filter_menu"].dropdownVisible = false;
      },
      clear_filter: function () {
        this.final_selected_statusids=[]
        this.final_selected_paymentstatusids=[]
        this.selected_subtypes = [];
        this.selected_statusids = [];
        this.selected_paymentstatusids=[]
        this.selectedVisaType = []
        this.activeCases = true;
        this.initStatusIdsFilter=null,
        this.selectedSeasons = [];
        this.selectedStatus = [];
        this.selectedpremiumProcessing = [];
        this.selectedtypeNames = [];
        this.final_selected_peritioners = [];
        this.selected_peritioners = [];
        this.searchtxt = '';
        this.filter_searchtxt = '';
        this.initStatusIdsFilter = { "_id": "637f076578adb65c4c208e2d", "id": 1, "name": "Active", "sortName": "active" };
        this.page = 1;
        this.getInvoiceList();
        this.headerTypeNames = [];
        this.header_selected_petitioners = [];
        this.selected_createdDateRange["startDate"] = "";
        this.selected_createdDateRange["endDate"] = "";
        this.selected_deadLineDateRange["startDate"] = "";
        this.selected_deadLineDateRange["endDate"] = "";

        // this.$refs["filter_menu"].dropdownVisible = false;
  
      },

      getbeneficiaryMasterDataList(text = '') {
        let postData = {
          "matcher": {
            "title": text,
            "statusList": [],
            "branchIds": [],
            "companyIds": [], // Required only for Tenant Admin and Branch Manager to list Beneficiaries
            "createdByIds": [],
            "createdDateRange": [],
            "roleIds": [51],
            "statusIds": [],
            "petitionTypeIds": [],
            "petitionSubTypeIds": [],
            "petitionCreatedDateRange": [],
            "petitionStatusIds": [],
            "getPetitionStats": true
          },
          "sorting": {
            "path": "createdOn", // invitedByName, updatedOn, name, email, phone, statusName, roleName
            "order": 1
          },
          "page": 1,
          "perpage": 1000000,
          "getMasterData": true,
          "getBeneficiaryList": true, // Required only for Tenant Admin and Branch Manager to list Beneficiaries
          "branchId": "", // Required when 'getMasterData' is true and roleIds are [4, 5, 6, 7, 8, 9, 10, 11]
          "companyId": "" // Required when 'getMasterData' is true and roleIds are [50, 51]
        };
  
        this.enableAddNewBenTag = false;
        if (this.checkProperty(this.selectedPetitioner, "_id")) {
  
          postData['companyId'] = this.selectedPetitioner['_id']
  
        }
        if ([50, 51].indexOf(this.getUserRoleId) > -1) {
  
          postData['companyId'] = this.checkProperty(this.getUserData, "companyDetails", "_id")
        }
        //this.beneficiaryMasterDataList =[];
        this.$store
          .dispatch("petitioner/getbeneficiaries", postData)
          .then(response => {
            this.beneficiaryMasterDataList = response.list;
  
            let filteredData = [];
            _.forEach(this.beneficiaryMasterDataList, (item) => {
              if (item && (_.has(item, 'name') || _.has(item, 'email'))) {
  
                if ((_.has(item, 'name') && item['name'].includes(text)) || (_.has(item, 'email') && item['email'].includes(text))) {
                  filteredData.push(item)
                } else {
                  return false;
                }
  
              } else {
                return false;
              }
  
  
            })
  
            if(filteredData.length<=0){
             this.enableAddNewBenTag =true;
           }
           let  beneficiaryMasterDataList = _.cloneDeep(this.beneficiaryMasterDataList);
           this.beneficiaryMasterDataList =[];
           _.forEach(beneficiaryMasterDataList, (item)=>{
            if(this.checkProperty(item,'name')){
              if(this.checkProperty(item ,'email') ){
                item['name'] =  item['name']+" ("+item['email']+")"
              }
              this.beneficiaryMasterDataList.push(item);
            }
          
          })
  
  
          })
  
      },


      setPetDetails(selectedPetitioner = null) {
  
        this.selectedPetitioner = selectedPetitioner
      },



      getPetitioners(callFromSerch = false, searchText = '') {
  
        let _self = this;
        let query = {
          "matcher": {
            "searchString": searchText,
            "statusIds": [],
            "countryIds": [],
            "stateIds": [],
            "locationIds": [],
            "createdDateRange": []
          },
          "sorting": { "path": "createdOn", "order": 1 },
          "page": 1,
          "perpage": 100,
          getMasterData: true
        }
  
  
        this.$store.dispatch("getList", { data: query, path: '/company/list' }).then(response => {
  
          _self.petitionersList = response.list;
  
        }).catch((err) => {
          this.petitionersList = [];
  
        })
      },







  
  
    },
    mounted() {
      this.getVisaTypes();
      this.getPendingInvoiceList();
      if (this.checkProperty(this.getUserData, 'tenantDetails') && this.checkProperty(this.getUserData, 'tenantDetails', 'slug') != 'slg') {
        this.isSlg = false;
      }
      // this.checkCapRegcase(true);
     
      this.sortKeys = {
        beneficiaryName:1,
        beneficiaryCustomId:1,
        issuedToDetails:1,
        petitionType:1,
        invoiceRaiseDate:1
  
      },
        this.sortKey = { "path": 'updatedOn', "order": -1 };
      //caseStatusList
      this.getPetitioners();
      this.getbeneficiaryMasterDataList();
      this.getBranchList();
      this.getInternalStatusList();
      this.initStatusIdsFilter = { "_id": "637f076578adb65c4c208e2d", "id": 1, "name": "Active", "sortName": "active" };
      this.filterQueryPreSelect(true);
  

    },
    computed: {
      getSelectedObj(){
        return (data)=>{
          let returnVal = false;
          let list = [];
          let petition = data['obj'];
          if(this.checkProperty(petition,'feeDetails') && this.checkProperty(petition,'feeDetails','length')>0 ){
            _.forEach(petition['feeDetails'], (item)=>{
              if(item && item['isSelected'] && !item['isAlreadyExist']){
                list.push(item)
              }
            })
          }
          if(list&& list.length>0){
            returnVal = true
          }
          return returnVal
      }
        

      },
      enableSelectedAll(){
        let returnVal = false;
        let list = [];
        if(this.checkProperty(this.pendingInvoiceList, 'length')>0){
          _.forEach(this.pendingInvoiceList, (mItem)=>{
            if(this.checkProperty(mItem,'feeDetails') && this.checkProperty(mItem,'feeDetails','length')>0 ){
              _.forEach(mItem['feeDetails'], (item)=>{
                if(item && item['isSelected'] && !item['isAlreadyExist']){
                  list.push(item)
                }
              })
            }
          })
        }
        if(list && list.length>0){
          returnVal = true
        }
        if(returnVal == false){
          this.selectAllInvoices = false
        }
        return returnVal
      },
      getselectedForInvoicesList(){
        let returnVal = false;
        if(this.checkProperty(this.selectedForInvoicesList, 'length')>0){
          returnVal = true;
        }
        return returnVal
      }
      
    },
   
  };
  </script>